import React from 'react';
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from '../utils/animationVariants';

import MediaPage from '../components/MediaSection';

function Media() {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <MediaPage />
    </motion.div>
  );
}

export default Media;
